export function isElectronEnv() {
  return window.timelyDesktop != null;
}
